"use client";

import { useEffect } from "react";
import {
  trackBannerClick,
  trackBannerImpression,
} from "@/app/utilities/apis";

type Props = {
  divId: string;
  campaignId: string;
  platformId: string;
  brand: string;
  deviceType: string;
  placeholderId: string;
};

export default function BannerTracker({
  divId,
  campaignId,
  platformId,
  brand,
  deviceType,
  placeholderId,
}: Props) {
  useEffect(() => {
    const element = document.getElementById(divId);

    if (!element) return;

    let hasTrackedImpression = false;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || hasTrackedImpression) return;

        hasTrackedImpression = true;

        if (campaignId && placeholderId) {
          trackBannerImpression(
            campaignId,
            platformId,
            brand,
            deviceType,
            placeholderId
          ).catch(console.error);
        }
      },
      {
        threshold: 0.5,
      }
    );

    observer.observe(element);

    const handleClick = () => {
      if (!campaignId || !placeholderId) return;

      trackBannerClick(
        campaignId,
        platformId,
        brand,
        deviceType,
        placeholderId
      ).catch(console.error);
    };

    element.addEventListener("click", handleClick);

    return () => {
      observer.disconnect();
      element.removeEventListener("click", handleClick);
    };
  }, [
    divId,
    campaignId,
    platformId,
    brand,
    deviceType,
    placeholderId,
  ]);

  return null;
}